<template>
  <div :id="id">
    <div class="column-title">k/件</div>
  </div>
</template>
<script>
import G2 from "@antv/g2";

export default {
  name: "barchart",
  props: ["chartData", "chartId"],
  data() {
    return {
      data: [],
      id: "",
      chart: {}
    };
  },
  watch: {
    chartData(newVal) {
      this.data = newVal;
      // console.log(newVal)
      this.chart.changeData(this.data);
    }
  },
  created() {
    this.id = this.chartId;
    this.data = this.chartData;
  },
  mounted() {
    this.chart = new G2.Chart({
      container: this.id,
      forceFit: true,
      height: document.querySelector("#" + this.id + "").clientHeight,
      width: document.querySelector("#" + this.id + "").clientWidth,
      padding: [38, 0, 37, 'auto']
    });
    this.chart.source(this.data);

    this.chart.axis('date', {
      label: {
        textStyle: {
          fill: '#fff'
        }
      },
      tickLine: {
        alignWithLabel: false,
        length: 0
      },
      line: {
        lineWidth: 1,
        stroke: '#3fe8f6'
      }
    });
    this.chart.axis('value', {
      label: {
        textStyle: {
          fill: '#fff'
        },
        formatter: function formatter(text) {
          return text.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        }
      },
      line: {
        lineWidth: 1,
        stroke: '#3fe8f6'
      }
    });
    this.chart.legend({
      textStyle: {
        fill: '#fff'
      },
      position: 'top-right',
       marker: 'square'
    })
    this.chart.line().position('date*value').color('type',['#3fe8f6', '#fd8c3c', '#f43a61']);
    this.chart.render();
  }
};
</script>
<style lang="scss" scoped>
#analys-chart {
  position: relative;
  width: 100%;
  height: 100%;
  .column-title {
    position: absolute;
    left: 8px;
    top: 8px;
    color: #fff;
    font-size: 12px;
  }
}
</style>
